import JsonLd from "./JsonLd";
import schemas from "./schemas";

/*
 * Organization + WebSite structured data. Mount ONCE, site-wide (App.js).
 * Provides the Organization node that the per-page Article/Tool schemas
 * reference by @id.
 */
export default function SiteSchema() {
  return <JsonLd data={schemas.buildSiteGraph()} />;
}
